import { Grid } from "@mui/material"
import MyTextField from "../../../components/MyTextField";
import { EmployeContracts } from "../../../interfaces/employeeDocuments.interface";
import { getDatestring } from "../../../utils/date";

export interface MyPositionProps {
    contractInformation: EmployeContracts | null;
}

export const MyPosition = ({contractInformation}: MyPositionProps) => {
    return (
        <Grid container direction="row" item width="100%" rowSpacing={"1rem"} style={{margin: "0"}}>
            <Grid item xs={12}>
                <MyTextField label="Cargo" value={contractInformation?.Cargo || ""} style={{width: "100%"}} disabled />
            </Grid>
            <Grid item xs={12}>
                <MyTextField label="Área" value={contractInformation?.Area || ""} style={{width: "100%"}} disabled />
            </Grid>
            {/* <Grid item xs={12}>
                <MyTextField label="División" value={"**"} style={{width: "100%"}} disabled />
            </Grid> */}
            <Grid item xs={12}>
                <MyTextField label="Empresa" value={contractInformation?.Empresa || ""} style={{width: "100%"}} disabled />
            </Grid>
            {/* <Grid item xs={12}>
                <MyTextField label="Centro de costos" value={"**"} style={{width: "100%"}} disabled />
            </Grid>
            <Grid item xs={12}>
                <MyTextField label="Supervisor" value={"**"} style={{width: "100%"}} disabled />
            </Grid>
            <Grid item xs={12}>
                <MyTextField label="Equipo" value={"**"} style={{width: "100%"}} disabled />
            </Grid>
            <Grid item xs={12}>
                <MyTextField label="Suplente" value={"**"} style={{width: "100%"}} disabled />
            </Grid> */}
            <Grid item xs={12}>
                <MyTextField label="Tipo de contrato" value={contractInformation?.TipoContrato || ""} style={{width: "100%"}} disabled />
            </Grid>
            <Grid item xs={12}>
                <MyTextField label="Jornada laboral" value={contractInformation?.JornadaHorario || ""} style={{width: "100%"}} disabled />
            </Grid>
            <Grid item xs={12}>
                <MyTextField 
                    label="Fecha Ingreso Compañia" 
                    value={contractInformation?.FechaInicio
                        ? getDatestring(contractInformation.FechaInicio.split("T")[0], "-", false) 
                        : ""
                    } 
                    style={{width: "100%"}} 
                    disabled 
                />
            </Grid>
            {/* <Grid item xs={12}>
                <MyTextField label="Saldo Vacaciones" value={"**"} style={{width: "100%"}} disabled />
            </Grid> */}
        </Grid>
    )
}
